import { render } from "./OrderConfirm.vue?vue&type=template&id=2b2364ce"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=2b2364ce&lang=css"
script.render = render

export default script